<template>
    <SidebarPanel
        dusk="ReaderTableOfContents"
        :is-open="ui.tableOfContents.opened"
        :title="title"
        side="left"
        persistent
        mobile-fullscreen
        @close="toggleTableOfContents"
    >
        <ul v-if="showTableOfContent" class="m-0 list-none p-0">
            <ContentList
                v-for="(item, index) in publication.table_of_contents"
                :key="index"
                :item="item"
                :class="{ disabled: isPreviewMode }"
            />
        </ul>

        <div v-else role="status" aria-live="polite" class="flex h-full items-center justify-center text-center">
            <p class="px-4 text-[15px] font-medium text-[color:var(--theme-text-color)] opacity-60">
                {{ localizations[lang].tableOfContentsNotAvailable }}
            </p>
        </div>
    </SidebarPanel>
</template>

<script>
'use strict';

import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import ContentList from './partials/ContentList.vue';
import SidebarPanel from '../Components/SidebarPanel.vue';

export default {
    components: {
        ContentList,
        SidebarPanel,
    },
    computed: {
        ...mapState(['publication', 'ui', 'localizations', 'lang', 'title']),
        ...mapGetters(['isPreviewMode']),
        showTableOfContent() {
            return this.publication.table_of_contents?.length > 0;
        },
    },
    methods: {
        ...mapMutations(['closeSidebar']),
        ...mapActions(['toggleTableOfContents']),
    },
};
</script>
